import { useTestIds } from '../../hooks';
import { withTestIds } from '../../utils';

import {
  ClassificationMarkingGlobalStyle,
  StyledClassifiedContent,
  StyledMarking
} from './ClassificationMarking.styles';
import type { ClassificationMarkingProps } from './ClassificationMarking.types';
import { getClassificationMarkingTestIds } from './ClassificationMarking.test-ids';

const ClassificationMarking = ({
  testId,
  label,
  background,
  color,
  fontFamily,
  fontSize,
  height,
  children
}: ClassificationMarkingProps) => {
  const testIds = useTestIds(testId, getClassificationMarkingTestIds);
  return (
    <>
      <ClassificationMarkingGlobalStyle height={height} />
      <StyledMarking
        background={background}
        color={color}
        fontFamily={fontFamily}
        fontSize={fontSize}
        height={height}
        placement='top'
        data-testid={testIds.top}
      >
        {label}
      </StyledMarking>
      <StyledClassifiedContent height={height} data-testid={testIds.content}>
        {children}
      </StyledClassifiedContent>
      <StyledMarking
        background={background}
        color={color}
        fontFamily={fontFamily}
        fontSize={fontSize}
        height={height}
        placement='bottom'
        data-testid={testIds.bottom}
      >
        {label}
      </StyledMarking>
    </>
  );
};

export default withTestIds(ClassificationMarking, getClassificationMarkingTestIds);
